/**
 * Phase 126.J — Classroom Support Hub read-guides tracker.
 *
 * Records which reference guides (adhd / giftedness / autism / 2e) a
 * visitor has read in localStorage, so the Hub can surface a soft
 * "read all four — they're written as a set" nudge once they've read
 * one or two but not all of them.
 *
 * Privacy-safe by design: only the slug list is stored, no user
 * identifier, no timestamps, no PII. Same domain as the rest of the
 * app's anonymous `teacher_id` storage. Safe to call without auth.
 */
const STORAGE_KEY = "atomicedu_hub_guides_read";

export const HUB_GUIDE_SLUGS = ["adhd", "giftedness", "autism", "2e"];

function safeRead() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((s) => HUB_GUIDE_SLUGS.includes(s));
  } catch {
    return [];
  }
}

function safeWrite(slugs) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(slugs));
  } catch {
    /* ignore — quota / privacy mode */
  }
}

export function getReadGuides() {
  return safeRead();
}

export function markGuideRead(slug) {
  if (!HUB_GUIDE_SLUGS.includes(slug)) return;
  const current = safeRead();
  if (current.includes(slug)) return;
  safeWrite([...current, slug]);
}
